import clsx from 'clsx';
import { useState } from 'react';

const TabSelector = ({
  className = '',
  options,
  value: controlledValue,
  onChange,
}: {
  options: { label: string; value: string }[];
  variant: 'primary' | 'secondary' | 'tertiary' | 'warning' | 'error';
  size: 'xs' | 'sm' | 'md' | 'lg';
  value?: string;
  onChange: (value: string) => void;
  className?: string;
}) => {
  const [internalValue, setInternalValue] = useState(options[0].value);
  const selectedValue = controlledValue !== undefined ? controlledValue : internalValue;

  const handleTabClick = (value: string) => {
    setInternalValue(value);
    onChange(value);
  };

  return (
    <>
      <div className="flex justify-center">
        <div className={clsx('inline-flex bg-gray-100 rounded-xl p-1 gap-1', className)}>
          {options.map(option => (
            <button
              key={option.value}
              className="px-6 py-2.5 rounded-lg text-sm font-semibold transition-all text-muted-foreground hover:text-foreground"
              onClick={() => handleTabClick(option.value)}
              style={{
                backgroundColor: selectedValue === option.value ? 'var(--blue-color)' : 'transparent',
                color: selectedValue === option.value ? 'white' : 'var(--gray-color)',
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default TabSelector;
